import UpdateSiteVisitDetails from "src/components/feature/ProjectDetailView/Forms/UpdateSiteVisitDetails";

const UpdateSiteVisitDetailsPage = () => {
  return <UpdateSiteVisitDetails />;
};

export default UpdateSiteVisitDetailsPage;
